<template>
  <v-card variant="tonal" class="mb-5">
    <v-card-title :style="{'color': appStyle.title_text_color}">
      <v-icon class="mx-3 my-1" size="small" :icon="mdiListBox" />
      {{ $t('mission-planning.info.flash-news.title') }}
    </v-card-title>

    <v-divider />

    <v-card-text>
      <div
        v-if="posFlashNews?.length"
        v-for="item in posFlashNews"
      >
        <div class="mx-3 my-3">
          <div class="text-body-1 font-weight-bold text-teal-darken-3">
            <a v-if="item.links?.length === 1" :href="item.links[0]" target="_blank">
              {{ `${item.title}` }}
            </a>
            <span v-else>
              {{ `${item.title}` }}
            </span>
          </div>

          <div class="text-body-1">
            {{ item.argument_text }}
          </div>

          <div v-if="item.links">
            <div class="text-body-1" v-for="link in item.links">
              <a :href="link" target="_blank">
                <v-icon :icon="mdiLinkVariant"></v-icon> {{ link }}
              </a>
            </div>
          </div>
        </div>

        <v-divider></v-divider>
      </div>

      <v-alert
        v-if="!posFlashNews?.length"
        variant="tonal"
        type="warning"
        :text="$t('mission-planning.info.informative-answer.message.no-instructions')"
      />
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed } from 'vue';
import { mdiListBox } from '@mdi/js';
import { extractFlashNewsByPosData } from '@/stores/manager/flashNewsManager';
import { mdiLinkVariant } from '@mdi/js';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();
const appStyle = computed(() => applicationStore.appStyle);

const props = defineProps({
  flashNews: {
    type: Object,
    required: true
  },
  pointOfSale: {
    type: Object,
    required: true
  }
});

const posFlashNews = extractFlashNewsByPosData(props.flashNews, props.pointOfSale);

</script>
